export var ONE_DAY = 1000 * 60 * 60 * 24 * 1;
export var ONE_MONTH = ONE_DAY * 30;
export var SIX_MONTHS = ONE_MONTH * 6;
export var ONE_YEAR = SIX_MONTHS * 2;
var IP_DOMAIN_PATTERN = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)/;

var getDefaultDomain = () => {
  if (typeof window === 'undefined') return '';

  if (IP_DOMAIN_PATTERN.test(window.location.host)) {
    var [domain] = window.location.host.split(':');
    return domain;
  }

  return window.location.host.split('.').reverse().slice(0, 3).reverse().join('.').replace(/(:\d{2,})/, '');
};

var DEFAULT_DOMAIN = getDefaultDomain();

var getExpiration = time => {
  var today = new Date();
  var expiration = new Date();
  expiration.setTime(today.getTime() + time);
  return expiration;
};

export var getCookie = function getCookie(name, cookieAsText) {
  if (cookieAsText === void 0) {
    cookieAsText = '';
  }

  var cookieValue = typeof window === 'undefined' ? cookieAsText : document.cookie;
  var cookieCollection = decodeURIComponent(cookieValue).split(';');
  var cookie = cookieCollection.reduce((cookieAcc, currentCookieText) => {
    var [key, value] = currentCookieText.split('=');
    cookieAcc[key.trim()] = value;
    return cookieAcc;
  }, {});
  return cookie[name];
};
export var setCookie = _ref => {
  var {
    name,
    value,
    expiresAt,
    domain,
    secure
  } = _ref;
  var expiration = typeof expiresAt === 'string' ? expiresAt : getExpiration(expiresAt);
  document.cookie = name + "=" + value + "; path=/; expires=" + expiration + "; " + (secure ? 'Secure;' : '') + " domain=" + (domain || DEFAULT_DOMAIN);
};
//# sourceMappingURL=index.js.map